import aos from "aos";

aos.init({
    duration: 500,
    once: true,
});

import fitvids from "fitvids";

fitvids(".video");

// Add class to html when user is tabbing, so we can add focus styles
function handleFirstTab(e) {
    if (e.keyCode === 9) {
        // the "I am a keyboard user" key
        document.documentElement.classList.add("user-is-tabbing");
        window.removeEventListener("keydown", handleFirstTab);
    }
}

window.addEventListener("keydown", handleFirstTab);

import nav from "./modules/nav";

nav();

// import ajaxForms from './modules/ajax-forms'
// ajaxForms()

import animations from "./modules/animations";

animations();

import jobSearch from "./modules/job-search";

jobSearch();

import filterSelect from "./modules/filter-select";

filterSelect();

import imgAnimate from "./modules/img-animate";

imgAnimate();

const tabsComponentBp = 720;

import Tabs from "./modules/tabs";

Tabs();

import TabsList from "./modules/tabs-list";

TabsList();

import TabPanels from "./modules/tab-panels";

TabPanels();

import TabsComponent from "./modules/tabs-component";

TabsComponent(tabsComponentBp);

import Glide from "@glidejs/glide";

const glides = document.querySelectorAll(".glide");
for (const glide of glides) {
    if (glide.classList.contains("glide-candidates")) {
        new Glide(glide, {
            perView: 3,
        }).mount();
        continue;
    }

    new Glide(glide).mount();
}

import Signup from "./modules/signup";

Signup();
